@switch (payload().type) {
  @case ('text') {
    <bevvi-text-payload [payload]="textPayload()!" />
  }

  @case ('confirmation') {
    <bevvi-confirmation-payload
      [payload]="confirmationPayload()!"
      [disabled]="disabled()"
      (userReply)="userReply.emit($event)"
    />
  }

  @case ('select') {
    <bevvi-select-payload
      [payload]="selectPayload()!"
      [disabled]="disabled()"
      (userReply)="userReply.emit($event)"
    />
  }

  @case ('multiselect') {
    <bevvi-multiselect-payload
      [payload]="multiselectPayload()!"
      [disabled]="disabled()"
      (userReply)="userReply.emit($event)"
    />
  }

  @case ('order-summary') {
    <bevvi-order-summary-payload
      [payload]="orderSummaryPayload()!"
      [disabled]="disabled()"
      (userReply)="userReply.emit($event)"
    />
  }

  @case ('time-slot') {
    <bevvi-time-slot-payload
      [payload]="timeSlotPayload()!"
      [disabled]="disabled()"
      (userReply)="userReply.emit($event)"
    />
  }

  @case ('link') {
    <bevvi-link-payload [payload]="linkPayload()!" />
  }
}
